import { render, staticRenderFns } from "./TipsFetch.vue?vue&type=template&id=2b55d6a0&scoped=true&"
import script from "./TipsFetch.vue?vue&type=script&lang=js&"
export * from "./TipsFetch.vue?vue&type=script&lang=js&"
import style0 from "./TipsFetch.vue?vue&type=style&index=0&id=2b55d6a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b55d6a0",
  null
  
)

export default component.exports